import { render, staticRenderFns } from "./CampaignSending.vue?vue&type=template&id=403f8956&"
import script from "./CampaignSending.vue?vue&type=script&lang=js&"
export * from "./CampaignSending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports